/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

interface CloseBtnProps {
  id: string;
  text: string;
  handleCloseClick: () => void;
}

const CloseBtn: FC<CloseBtnProps> = ({ id, text, handleCloseClick }) => {
  return (
    <NeuButton
      id={id}
      aria-label={`close ${text}`}
      color="blue"
      icon="close"
      size="small"
      kind="primary"
      onClick={handleCloseClick}
    >
      {`Close ${text}`}
    </NeuButton>
  );
};

export default CloseBtn;
